import * as React from 'react';
import {DataGrid, deDE, GridColDef} from '@mui/x-data-grid';
import useLicensesQuery from "../hooks/useLicensesQuery";
import useClientQuery from "../../../global/queries/useClientQuery";

export default function LicensesDataTable() {

    const {data: client} = useClientQuery()
    const {data: licences} = useLicensesQuery();

    const columns: GridColDef[] = [
        {field: 'artnr', headerName: 'Kurzform', width: 80},
        {field: 'artnrDescription', headerName: 'Modul', flex: 1},
        {
            field: 'menge',
            headerName: 'Menge - Shared',
            type: 'number',
            width: 150,
        },
        {
            field: 'clientInfo',
            headerName: 'Menge - Einzelplatz',
            width: 200,
            valueGetter: () => client?.einzelplatzlizenzNr?.replace(".0", ""),
        },
    ];

    if (!licences) return <h1>undefined</h1>

    return <DataGrid
        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
        sx={{minHeight: 500}}
        rows={licences || []}
        columns={columns}
        getRowId={(row) => row.recId}
        initialState={{
            pagination: {
                paginationModel: {
                    pageSize: 10,
                },
            },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
    />
}